<template>
  <div class="sub_container bg_none">
    <div class="mddcnt-wrap">
      <div class="inner-wrap">
        <div class="img-wrap">
          <i class="ico ico_err" />
        </div>
        <div class="txt-wrap">
          <h2 class="em-txt">페이지가 만료되었습니다.</h2>
          <p class="txt">
            원클릭 사이트를 통해서<br />
            서류제출내역을 확인해주세요.
          </p>
        </div>
      </div>
    </div>
    <!-- // inner-wrap -->
  </div>
</template>

<script>
export default {};
</script>
